import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { connect } from 'react-redux';

import {
    fetchUsuariRestablirContrasenya
} from '../../commons/consultesServidor';

import {
    crearNotificacioSuccess
} from '../../commons/notificacio';

import {
    errorConsultaServidor
} from '../../actions/error';

import {
    RETARD_MILISEGONS_APARICIO_SPINNER
} from '../../constants';

const missatgeExitRestablintContrasenya = 'Contrasenya restablerta correctament';
const missatgeErrorRestablintContrasenya = 'Error restablint contrasenya';

class UsuariDetallRestablirContrasenya extends Component {

    constructor(props) {
        super(props);
        this.state = { modalVisible: false, peticioEnCurs: false };
        this.mostrarModal = this.mostrarModal.bind(this);
        this.amagarModal = this.amagarModal.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
    }

    onClickOk() {
        this.setState({...this.state, peticioEnCurs: true});
        return fetchUsuariRestablirContrasenya(this.props.idUsuari)
            .then(
                () => {
                    this.setState({modalVisible: false, peticioEnCurs: false});
                    crearNotificacioSuccess(missatgeExitRestablintContrasenya);
                },
                (errorServidor) => {
                    this.setState({modalVisible: true, peticioEnCurs: false});
                    this.props.errorConsultaServidor(errorServidor, missatgeErrorRestablintContrasenya);
                }
            );
    }

    mostrarModal() {
        this.setState({...this.state, modalVisible: true});
    }

    amagarModal() {
        this.setState({...this.state, modalVisible: false});
    }

    render() {

        const { modalVisible, peticioEnCurs } = this.state;
        const loadingBotoOK = peticioEnCurs ? {delay: RETARD_MILISEGONS_APARICIO_SPINNER} : false;

        return (
            <div>
                <Button size='large' type="primary" onClick={this.mostrarModal}>
                    Restablir contrasenya
                </Button>
                <Modal
                    visible={modalVisible}
                    title='Restablir contrasenya'
                    closable={false}
                    footer={[
                        <Button key="ok" type="primary" loading={loadingBotoOK} onClick={this.onClickOk}>OK</Button>,
                        <Button key="cancel" disabled={peticioEnCurs} onClick={this.amagarModal}>Cancel·lar</Button>,
                    ]}
                >
                    <p>{'La contrasenya actual de l\'usuari es substituirà pel seu codi postal.'}</p>
                    <p>{'Voleu continuar?'}</p>
                </Modal>
            </div>
        );
    }

}

UsuariDetallRestablirContrasenya.propTypes = {
    idUsuari: PropTypes.number,
    errorConsultaServidor: PropTypes.func
};

const mapDispatchToProps = {
    errorConsultaServidor
};

export default connect(null, mapDispatchToProps)(UsuariDetallRestablirContrasenya);



// WEBPACK FOOTER //
// ./src/components/usuari/usuariDetallRestablirContrasenya.js